module.exports = __webpack_public_path__ + "static/img/slide-arrow-left.11095634.svg";